import request from '@/utils/request'

const mockUrl = 'http://47.99.191.4:6006/mock/260'
const payApiUrl = process.env.VUE_APP_PAY_API

// 供应商员工缴费记录
export function getExpenseBillingApi(params) {
  return request(
    {
      url: payApiUrl + '/v1/order/page/buyer',
      method: 'get',
      params
    },
    {
      needLoading: true
    }
  )
}

// 供应商申请开票
export function applyInvoiceApi(data) {
  return request(
    {
      url: payApiUrl + '/v1/invoiceApply/apply',
      method: 'post',
      data
    },
    {
      needLoading: true
    }
  )
}

// 供应商发票申请记录
export function getInvoiceApplyListApi(params) {
  return request(
    {
      url: payApiUrl + '/v1/invoiceApply/page/buyer',
      method: 'get',
      params
    },
    {
      needLoading: true
    }
  )
}

// 供应商发票记录的支付列表
export function getInvoicePayListApi(invoiceApplyId) {
  return request(
    {
      url: payApiUrl + `/v1/order/${invoiceApplyId}/buyer`,
      method: 'get'
    },
    {
      needLoading: true
    }
  )
}

// 获取发票下载列表
export function getInvoiceDownloadListApi(id) {
  return request(
    {
      url: payApiUrl + `/v1/invoiceApply/invoiceDetail/List/${id}`,
      method: 'get'
    },
    {
      needLoading: true
    }
  )
}
